export const CLIENT_TYPING = 'CLIENT_TYPING'
export const CLIENT_SEND_MESSAGE = 'CLIENT_SEND_MESSAGE'
